import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetSutsResponse
} from '@eggplant/types'
import type { SutQuery } from './types'

interface Props {
  params?: SutQuery
  onError?: (error: Error) => void
  onSuccess?: (response: GetSutsResponse) => void
  children?: (response: GetSutsResponse) => ReactElement
  shortErrorMessage?: string
}

const GetComposerSutsRequest = ({
  params,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const { requestParams } = useGetParamsWithSpaceId<SutQuery|undefined>(params)

  const url = `${API_COMPOSER_SERVICE}/suts`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetComposerSutsRequest
